module.exports = __webpack_public_path__ + "static/media/Raggruppa_72.abb2b56f.svg";